import { CanActivateFn, Router } from '@angular/router'
import { AuthorizationService } from '@services/authorization.service'
import { AccountService } from '@services/account.service'
import { AuthService } from '@services/auth.service'
import { catchError, map, of } from 'rxjs'
import { inject } from '@angular/core'

export const authorizationContextGuard: CanActivateFn = () => {
	const router = inject(Router)
	const authService = inject(AuthService)
	const accountService = inject(AccountService)
	const authorizationService = inject(AuthorizationService)

	if (authorizationService.initialized()) {
		return true
	}

	return authorizationService.loadAuthorizationContext(accountService.tenantId).pipe(
		map(() => true),
		catchError(() => {
			authService.resetSession(true)
			return of(router.createUrlTree(['/auth/signin']))
		})
	)
}
